// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,

  data: {
    baseUrl: 'https://dev-api.cloudotdr.com/web/v1',
    gatewayKey: 'd1830a6308e2480792ef51a754a554fa',
  },

  numberOfDaysOfHistory: 10,
  primengLicense: 'eyJpZCI6ImJmMzY0ZmY4LTNhN2MtNDRmMi1hYzQyLThlZWZlZDFiMGJkZCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3OTI2MDYzNTMsImV4cCI6MTgyNDE0MjM1M30.LJvU31mInIbXhsiE9hsPsMMIFdRWUT7llionJT5Gu3I3GbMwtS3N264ChCAUA4e5GGmb18Q89Ze4bcwr8538Ag',
  environmentStoragePrefix: 'dev_',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
